import BaseResource from './index'

export default class FlsaResource extends BaseResource {
    static endpoint = '/oasis/restv3/flsaTypes'
}
